module.exports = __webpack_public_path__ + "img/1WkbzW4lVHbUVbISsXmgMZTK0ML6RDZ4g.8a111840.png";